// extracted by mini-css-extract-plugin
module.exports = {"border-color":"var(--accent-12)","cell":"Cell_cell__5VuSx"};